import { TestOrganization } from './types';

// Audit on Platform test organizations from wiki
export const futureOfAudit1Organization: TestOrganization = {
  highbondId: '314',
  name: 'Future of Audit 1',
  urlPrefix: 'future-of-audit-1',
  id: 'foa1-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'future-of-audit-1',
};

export const auditOnPlatformDevOrganization: TestOrganization = {
  highbondId: '4558',
  name: 'Audit on Platform Dev',
  urlPrefix: 'audit-on-platform-dev',
  id: 'aopd-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'audit-on-platform-dev',
};

export const futureOfAuditTwOrganization: TestOrganization = {
  highbondId: '4454',
  name: 'Future of Audit TW',
  urlPrefix: 'future-of-audit-tw',
  id: 'foat-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'future-of-audit-tw',
};

export const foaSandboxOrganization: TestOrganization = {
  highbondId: '4470',
  name: 'FoA Sandbox',
  urlPrefix: 'foa-sandbox',
  id: 'foas-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'foa-sandbox',
};

export const aopProdTestNoRmOrganization: TestOrganization = {
  highbondId: '3115',
  name: 'AoP-prod-test no RM',
  urlPrefix: 'aop-prod-test-no-rm',
  id: 'aopp-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'aop-prod-test-no-rm',
};

export const dilitestOrganization: TestOrganization = {
  highbondId: '457',
  name: 'Dilitest',
  urlPrefix: 'dilitest',
  id: 'dili-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'dilitest',
};

export const foaQaAutomationAuditApiOrganization: TestOrganization = {
  highbondId: '767',
  name: 'FoA QA Automation Audit API',
  urlPrefix: 'foa-qa-automation-audit-api',
  id: 'foaq-833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'foa-qa-automation-audit-api',
};

export const devAuditOnPlatformTestOrganizations: TestOrganization[] = [
  futureOfAudit1Organization,
  auditOnPlatformDevOrganization,
  futureOfAuditTwOrganization,
  foaSandboxOrganization,
  aopProdTestNoRmOrganization,
  dilitestOrganization,
  foaQaAutomationAuditApiOrganization,
];
